import React from 'react';

const SidebarProfile = () => {
  return (
    <div className="profile__sidebar">
      <div className="space-y-40">
        <div className="space-y-10">
          <h5>About me</h5>
          <div className="box space-y-20">
            <p>
              I make art with the simple goal of giving you something pleasing
              to look at for a few seconds.
            </p>
            <div className="row">
              <div className="col-6">
                <span className="txt_sm color_text">NFTs</span>
                <h4>12</h4>
              </div>
              {/* <div className="col-6">
                <span className="txt_sm color_text">Creations</span>
                <h4>406</h4>
              </div> */}
            </div>
          </div>
        </div>
        <div className="space-y-10">
          <h5>Follow me</h5>
          <div className="box">
            <ul className="social_profile space-y-10 overflow-hidden">
              <li>
              <a href="https://www.facebook.com/" rel="noreferrer"  target="_blank">
                  <i className="ri-facebook-line" />
                  <span className="color_text">facebook/</span>
                  @weedheads
                </a>
              </li>
              <li>
              <a href="https://www.discord.com/" rel="noreferrer"  target="_blank">
                  <i className="ri-discord-line" />
                  <span className="color_text"> discord/</span>
                  @weedheads
                </a>
              </li>
              <li>
              <a href="https://twitch.com" target="_blank" rel="noreferrer" >
                  <i className="ri-twitch-line" />
                  <span className="color_text"> twitch/</span>
                  @weedheads
                </a>
              </li>
              <li>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" >
                  <i className="ri-youtube-line" />
                  <span className="color_text">youtube/</span>
                  @weedheads
                </a>
              </li>
              <li>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" >
                  <i className="ri-twitter-line" />
                  <span className="color_text">twitter/</span>
                  @weedheads
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p className="text-center txt_sm mt-20 color_text">Since 2021</p>
    </div>
  );
};

export default SidebarProfile;
